import NavBarDesktop from "./navbarDesktop";
import NavBarMobile from "./navbarMobile";



export default function NavBar({matches,handleFilterChange,setRealoding}){
    
    return(
        <>
            {matches ? <NavBarMobile matches={matches} setRealoding={setRealoding} handleFilterChange={handleFilterChange}/> : <NavBarDesktop />}
        </>
    )
}